import styled from "styled-components";

export const GeneralText = styled.div`
  font-size: 1em;
  word-wrap: anywhere;
`;
export const StyledHeader = styled.div`
  font-family: var(--heading-font), sans-serif;
  text-align: center;
  text-transform: uppercase;
  color: var(--color-text);
  font-size: clamp(1rem, -2rem + 9vw, 2rem);
  grid-column: span 2;
  padding-top: 10px;
`;